import { Controller } from "@hotwired/stimulus"
import GLightbox from "glightbox"

export default class extends Controller {
  connect() {
    this.lightbox = GLightbox({
      selector: '.glightbox',
      touchNavigation: true,
      keyboardNavigation: true,
      loop: true,
      autoplayVideos: true
    })
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
    }
  }
}